/* eslint-disable no-console */
<template>
  <div class="bg" v-show="show">
    <div v-if="Object.keys(o)&&o.list&&o.list.length > 0" @click="prevClick" :class="{prev: true, on: nowIndex==0}"></div>
    <div v-if="Object.keys(o)&&o.list&&o.list.length > 0" @click="nextClick" :class="{next: true, on: nowIndex==maxIndex}"></div>
    <div ref="materialBox" class="materialBox-container">
      <img @click="close" class="close" src="@assets/img/material/closeIcon.svg" alt="">
      <div v-if="showInput===false" class="title">
        <img alt="技审通过" title="技审通过" class="verify-logo" v-if="detail.has_audit==1" src="@assets/img/common/verify-success.svg">
        <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="detail.has_audit==2" src="@assets/img/common/verify-fail.svg">
        <p>{{detail.title}}</p>
        <img v-if="canEdit && detail.rename" @click="showInput=true" class="edit" src="@assets/img/material/editIcon.svg" alt="">
      </div>
      <div v-if="showInput" class="titleInput">
        <p class="input">
          <input @keydown.enter="renameAsset" v-model="titleInput" type="text">
          <span></span>
        </p>
        <p class="wordNumber">{{wordNum}}/40</p>
      </div>
      <div class="content-container">
        <div class="media-container">
          <div v-show="detail.type-0 === 2" class="video">
            <video ref="videoDom" controls controlsList="nodownload" contextmenu="none" :src="detail.url"></video>
            <div class="speedRate">
              <div @click="showSelectList=!showSelectList" class="btn">
                <span>{{nowSpeed}}</span>
                <img src="@assets/img/material/whiteArrow.svg" alt="">
              </div>
              <div v-if="showSelectList" class="btnList">
                <p></p>
                <ul>
                  <li @click="changeSpeed('1x')">1x</li>
                  <li @click="changeSpeed('2x')">2x</li>
                  <li @click="changeSpeed('4x')">4x</li>
                </ul>
              </div>
            </div>
          </div>
          <div ref="imgDom" v-show="detail.type-0 === 1" :style="{'background-image': `url(${detail.url})`}" class="img">
            <div v-for="(i,index) in picFaceList" :key="index" class="border" :style="'width:'+i.borderWidth+'px;height:'+i.borderHeight+'px;top:'+i.borderTop+'px;left:'+i.borderLeft+'px;'">
              <i>{{++index}}</i>
            </div>
          </div>
          <div v-show="detail.type-0 === 3" class="audio">
            <audio ref="audioDom" preload="load" :src="detail.url"></audio>
            <div class="control">
              <img src="@assets/img/material/disk.png" alt="">
              <img @click="audioPlay" v-if="isPlay === false" class="play" src="@assets/img/material/playIcon.svg" alt="">
              <img @click="audioPause" v-if="isPlay" class="pause" src="@assets/img/material/pauseIcon.svg" alt="">
            </div>
            <div class="progress-container">
              <div class="time">
                <span>{{nowTime}}</span>
                <span class="grey">/{{endTime}}</span>
              </div>
              <div ref="line" class="progress">
                <p @click="isMouseClick=true;clickJump($event)" class="progress-bg"></p>
                <p @click="isMouseClick=true;clickJump($event)" class="progress-fill" :style="'width:' + audioPercent">
                  <i @mouseenter.prevent="isMouseClick=false" @mouseout.prevent="timeNavi();isMouseClick=false;" @mousedown.prevent="isMouseClick=true;timeStop();isPlayAudio=false" @mouseup.prevent="timeNavi();isMouseClick=false;"
                    @mousemove.prevent="slideMouseMove"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!--todo 22 -->
        <div class="detail-container">
          <div class="tab-list">
            <div class="tabType">
              <ul ref="tabType">
                <li @click="tabIndex=item.index" v-for="(item,index) in tabList" :key="index" :class="tabIndex === item.index ? 'on' : ''">{{item.name}}</li>
              </ul>
            </div>
            <div class="btn">
              <p @click="leftClick" :class="{leftArrow: true, on: movedCount >=1}"></p>
              <p @click="rightClick" :class="{rightArrow: true, on: movedCount+3<tabList.length}"></p>
            </div>
          </div>

          <div v-if="tabIndex===0" class="detail">
            <div class="userInfo">
              <p  @click="showCard(detail.uid, $event)" class="name">
                <img src="@assets/img/material/userIcon.svg" alt="">
                <span>{{detail.username}}</span>
              </p>
              <p class="clock">
                <img src="@assets/img/material/clockIcon.svg" alt="">
                <span>{{detail.raw_add_time}}</span>
              </p>
            </div>

            <div class="info source">
              <div>
                <p>信源</p>
                <span>{{detail.source_info && detail.source_info.ptitle}}</span>
              </div>
              <div>
                <p>频道</p>
                <span>{{detail.source_info && detail.source_info.stitle}}</span>
              </div>
              <div>
                <p>上传来源</p>
                <span>{{detail.platform}}</span>
              </div>
              <div v-if="detail && detail.premiere_date">
                <p>首播日期</p>
                <span>{{detail.premiere_date}}</span>
              </div>
            </div>

            <div class="info format">
              <div>
                <p>格式</p>
                <span>{{detail.content && (detail.content.format || detail.content.type)}}</span>
              </div>
              <div v-if="detail.content && detail.content.duration">
                <p>时长</p>
                <span>{{detail.content && detail.content.duration}}</span>
              </div>
              <div v-if="detail.content && detail.content.rate">
                <p>码率</p>
                <span>{{detail.content && detail.content.rate}}</span>
              </div>
              <div>
                <p>大小</p>
                <span>{{detail.content && (detail.content.file_size || detail.content.size)}}</span>
              </div>
              <div v-if="detail.content && detail.content.pixel">
                <p>尺寸</p>
                <span>{{detail.content && detail.content.pixel}}</span>
              </div>
              <div v-if="detail.content && detail.content.resolution">
                <p>分辨率</p>
                <span>{{detail.content && detail.content.resolution}}</span>
              </div>
              <div v-if="detail.content && detail.content.fps">
                <p>帧率</p>
                <span>{{detail.content && detail.content.fps}}</span>
              </div>
            </div>

            <div class="sum">
              <div>
                <p>简介</p>
                <span v-show="editText===false">{{textArea}}<img v-if="canEdit" class="editIcon" @click="editText=true" src="@assets/img/material/editIcon.svg" alt=""></span>
                <div v-show="editText" class="textArea">
                  <textarea maxlength="200" v-model="textArea"></textarea>
                  <span @click="editText=false">确定</span>
                </div>
              </div>
            </div>
          </div>

          <div v-if="tabIndex===1" class="tab">
            <div class="input">
              <input type="text" v-model="tagInput" @keydown.enter="addTag" placeholder="请输入自定义标签，回车添加">
            </div>
            <div v-if="tagList.length == 0" class="empty">
              <img src="@assets/img/material/box.svg" alt="">
              <span>暂无内容</span>
            </div>
            <ul v-if="tagList.length > 0">
              <li :class="{on: canEdit==false}" v-for="(item,index) in tagList" :key="index">
                <span>{{item}}</span>
                <img v-if="canEdit" @click="delTag(index)" src="@assets/img/material/greyCloseIcon.svg" alt="">
              </li>
            </ul>
          </div>

          <div v-if="tabIndex===2" class="voiceRec-container">
            <div class="btn">
              <p @click="convertWord(detail)" v-if="detail.text_status-0 === 1" class="green">开始识别</p>
              <p @click="convertWord(detail)" v-if="detail.text_status-0 === 3  || detail.text_status-0 === 4" class="green">重新识别</p>
              <p v-if="detail.text_status-0 === 2"><img style="height: 100%;width: auto;" src="@assets/img/common/loading-g.svg" alt="loading" />识别中</p>
              <p @click="exportText">导出文字</p>
              <p @click="copyText">复制文字</p>
              <input style="position: absolute; top: -100000000000px" ref="wordList" type="text">
            </div>
            <div v-if="detail.text_status-0 != 3" class="empty">
              <img src="@assets/img/material/box.svg" alt="">
              <span>暂无内容</span>
            </div>
            <ul v-if="detail.text_status-0 === 3">
              <li v-for="(item,index) in wordList" :key="index">
                <span class="time">{{item.begin}}</span>
                <p>{{item.onebest}}</p>
              </li>
            </ul>
          </div>

          <div v-if="tabIndex===3" class="faceRec-container">
            <p v-if="detail.face_status-0 === 1" @click="faceRec" class="recBtn">开始识别</p>
            <p v-if="detail.face_status-0 === 3 || detail.face_status-0 === 4" @click="faceRec" class="recBtn">重新识别</p>
            <p v-if="detail.face_status-0 === 2" class="recBtn on"><img style="height: 100%;width: auto;" src="@assets/img/common/loading-g.svg" alt="loading" />识别中</p>
            <div v-if="detail.face_status-0 != 3 || (detail.type-0 === 1&&faceList.length === 0) || (detail.type-0 === 2&&videoFaceList.length === 0)" class="empty">
              <img src="@assets/img/material/box.svg" alt="">
              <span>暂无内容</span>
            </div>

            <ul v-if="detail.type-0 === 1&&detail.face_status-0 === 3" class="pic">
              <li v-for="(item,index) in faceList" :key="index">
                <div class="name">
                  <div class="left-container">
                    <div :class="{sensitive: true, on: item.optimal_face.secret_level > 0}">
                      <div :class="{sensitiveBorder: true, on: item.optimal_face.secret_level > 0}">
                        <div :style="{'background-image': `url(${item.optimal_face.pic_url})`}" class="img">
                          <p class="num">{{++index}}</p>
                        </div>
                      </div>
                    </div>
                    <p class="name">{{item.optimal_face.name}}</p>
                  </div>
                  <div @click="item.status=!item.status" class="right-container">
                    <span>详情</span>
                    <img :class="{on: item.status}" src="@assets/img/material/arrow.svg" alt="">
                  </div>
                </div>
                <div v-if="item.status && item.optimal_face.secret_level > 0" class="isSensitive">敏感人物</div>
                <div v-if="item.status" class="description">{{item.optimal_face.describe}}</div>
              </li>
            </ul>

            <ul v-if="detail.type-0 === 2&&detail.face_status-0 === 3" class="video">
              <li v-for="(item,index) in videoFaceList" :key="index">
                <div class="name">
                  <div class="left-container">
                    <div :class="{sensitive: true, on: item.secret_level > 0}">
                      <div :class="{sensitiveBorder: true, on: item.secret_level > 0}">
                        <div :style="{'background-image': `url(${item.face_image})`}" class="img"></div>
                      </div>
                    </div>
                    <p class="name">{{item.name}}</p>
                  </div>
                  <div @click="item.desStatus=!item.desStatus" class="right-container">
                    <span>详情</span>
                    <img :class="{on: item.desStatus}" src="@assets/img/material/arrow.svg" alt="">
                  </div>
                </div>
                <div v-if="item.desStatus && item.secret_level > 0" class="isSensitive-container">
                  <div class="isSensitive">敏感人物</div>
                </div>
                <div v-if="item.desStatus" class="description">{{item.describe}}</div>
                <div class="face-container">
                  <p @click="item.picStatus=!item.picStatus" class="btn">
                    <span>出现镜头</span>
                    <img :class="{on: item.picStatus}" src="@assets/img/material/arrow.svg" alt="">
                  </p>
                  <div v-if="item.picStatus" class="list">
                    <div v-for="(val,key) in item.result" :key="key" :style="{'background-image': `url(${val.frame_href})`}">
                      <p>{{val.first_time}}-{{val.last_time}}</p>
                      <div class="border" :style="'width:'+val.borderWidth+'px;height:'+val.borderHeight+'px;top:'+val.borderTop+'px;left:'+val.borderLeft+'px;'"></div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 视频技审 -->
          <div v-if="tabIndex===4" class="voiceRec-container videoRec-container">
            <div class="btn">
              <!-- loading 状态 -->
              <p :class="{full:detail.has_audit==0,loading:true}" v-if="detail.audit_status==2">
                <img style="height: 100%;width: auto;" src="@assets/img/common/loading-g.svg" alt="loading" />
                识别中
              </p>
              <!-- audit_status 技审状态//1:未提交 2:处理中 3:识别完成 4:识别失败 -->
              <!-- 如果没提交过 和 技审失败 todo -->
              <p class="full" :class="{green:!submitVideoAuditing}" v-if="detail.has_audit_role&&detail.has_audit<=0&&(detail.audit_status!=2&&detail.audit_status!=3)" @click="videoAudit">
                <img v-if="submitVideoAuditing" style="height: 100%;width: auto;" src="@assets/img/common/loading.svg" alt="loading" />
                技术识别
              </p>
              <!-- 识别过 -->
              <p v-else-if="detail.has_audit_role&&detail.has_audit>0&&(detail.audit_status-0>=3)" :class="{green:!submitVideoAuditing}" @click="videoAudit">
                <img v-if="submitVideoAuditing" style="height: 100%;width: auto;" src="@assets/img/common/loading.svg" alt="loading" />
                <span v-if="!submitVideoAuditing">
                  重新识别
                </span>
                <span v-else>
                  识别中
                </span>
              </p>
              <img class="logo" v-if="detail.has_audit==2" src="../../assets/img/common/verify-fail.svg" alt="">
              <div v-if="detail.has_audit==2" class="result">
                技审未通过
              </div>
              <img class="logo" v-if="detail.has_audit==1" src="../../assets/img/common/verify-success.svg" alt="">
              <div v-if="detail.has_audit==1" class="result">
                技审通过
              </div>
              <input style="position: absolute; top: -100000000000px" ref="wordList" type="text">
            </div>
            <!-- 成功的结果 -->
            <div v-if="detail.has_audit==1" class="empty">
              <div class="result-success">
                <img src="@assets/img/common/verify-success-result-logo.svg" alt="">
              </div>
              <span>审核通过</span>
            </div>
            <!-- 失败的信息结果 -->
            <ul v-else-if="detail.has_audit==2&&detail.audit_res.result&&detail.audit_res.result.length">
              <div class="js-title">
                <span class="time">时间</span>
                <span class="ml">结果</span>
              </div>
              <li v-for="(item,index) in detail.audit_res.result" :key="index">
                <p class="js-time">
                  <span>{{item.startTimeStr}}</span>
                  <span>{{item.endTimeStr}}</span>
                </p>
                <p class="js-result ml">{{item.label}}</p>
              </li>
            </ul>
            <!-- 未提交 和正在第一次识别中 和 技审失败-->
            <div v-else class="empty">
              <img src="@assets/img/material/box.svg" alt="">
              <span>暂无内容</span>
            </div>
          </div>
        </div>

        <div class="bottom-container">
          <div class="left-container">
            <div v-click-outside="closecreate" @click="clickCreate()" v-if="create.material||create.report||create.publish">
              <img class="create" src="@assets/img/material/cloudIcon.svg" alt="">
              <p>创建</p>
              <div v-show="isShowCreate" :style="'top:'+downloadPos1+';left:'+downloadPos1Left" class="createList">
                <div class="h10"></div>
                <ul>
                  <li v-if="create.material" @click="navigate('material',detail.id)">
                    <i class="uploadIcon"></i>
                    <span>上传线索</span>
                  </li>
                  <li v-if="create.report" @click="navigate('report',detail.id)">
                    <i class="reportIcon"></i>
                    <span>创建报道</span>
                  </li>
                  <li v-if="create.publish" @click="navigate('publish',detail.id)">
                    <i class="publicIcon"></i>
                    <span>创建发布</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="right-container">
            <div v-click-outside="closeDownload" @click="createdDownload()" v-if="(detail.has_low_quality_download_role || detail.has_high_quality_download_role) && detail.type != 1 && detail.type != 3">
              <img class="download" src="@assets/img/material/downloadIcon.svg" alt="">
              <p>下载</p>
              <div v-show="isShowDownload" :style="'top:'+downloadPos+';left:'+downloadPosLeft" class="createList">
                <div class="h10"></div>
                <ul>
                  <li @click="downloadSource(detail,0)" v-if="detail.has_low_quality_download_role">
                    <i class="eightIcon"></i>
                    <span>800K码流</span>
                  </li>
                  <li @click="downloadSource(detail,1)" v-if="detail.has_high_quality_download_role">
                    <i class="originIcon"></i>
                    <span>原始码流</span>
                  </li>
                </ul>
              </div>
            </div>
            <div @click="downloadSource(detail,1)" v-if="(detail.has_low_quality_download_role || detail.has_high_quality_download_role) && detail.type == 1">
              <img class="download" src="@assets/img/material/downloadIcon.svg" alt="">
              <p>下载</p>
            </div>
            <div @click="downloadSource(detail,1)" v-if="(detail.has_low_quality_download_role || detail.has_high_quality_download_role) && detail.type == 3">
              <img class="download" src="@assets/img/material/downloadIcon.svg" alt="">
              <p>下载</p>
            </div>
            <div v-if="detail.edit_role" @click="edit(detail.type)">
              <img class="edit" src="@assets/img/material/cutIcon.svg" alt="">
              <p>编辑</p>
            </div>
            <div v-if="quickEdit" @click="useDetail">
              <img class="use" src="@assets/img/material/addIcon.svg" alt="">
              <p>选用</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import store from "@common/store";
import vClickOutside from "v-click-outside";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  name: "MaterialBox",
  data() {
    return {
      submitVideoAuditing: false,//提交技审中
      movedCount: 0,//tab左移的个数
      show: true,
      config: {},
      detail: {},
      r: null,
      tabList: [],
      tabIndex: 0,
      tagList: [],
      editText: false,
      tagInput: null,
      isPlay: false,
      nowTime: "00:00:00",
      endTime: "00:00:00",
      duration: 0,
      percent: 0,
      audioPercent: "0%",
      isMouseClick: false,
      create: {
        interview: false,
        material: false,
        publish: false,
        report: false
      },
      wordList: [],
      callback: null,
      canEdit: true,
      showInput: false,
      titleInput: "",
      saveTitleInput: "",
      textArea: "无",
      wordNum: 0,
      showSelectList: false,
      nowSpeed: "1x",
      o: {},
      videoFaceList: [],
      faceList: [],
      faceOriginWidth: 0,
      faceOriginHeight: 0,
      imgListHeight: 74,
      imgListWidth: 132,
      imgListHeight1: 366,
      imgListWidth1: 650,
      picFaceList: [],
      nowIndex: 0,
      maxIndex: 0,
      quickEdit: true,
      t: null,
      d: null,
      downloadPos: '40px',
      downloadPos1: '40px',
      downloadPos1Left: '-5px',
      downloadPosLeft: '-5px',
      isShowCreate: false,
      isShowDownload: false
    };
  },
  mounted() {
    
    common.handleSocket(this.getTranstext, "pickuptext");
    common.handleSocket(this.getVideoDetail, "facerec");
    common.handleSocket(this.getVideoAudit, "audit");
    this.$nextTick(() => {
      if(this.$refs.materialBox.getBoundingClientRect().y < 90){
        // let top = this.$refs.materialBox.getBoundingClientRect().y + 60 - 90
        // this.downloadPos = top + 'px';
        // let top1 = this.$refs.materialBox.getBoundingClientRect().y + 60 - 130
        // this.downloadPos1 = top1 + 'px';
        this.downloadPos1 = '-10px';
        this.downloadPos1Left = '120px';
        this.downloadPos = '30px';
        // this.downloadPosLeft = '-125px';
      }
    })
  },
  watch: {
    titleInput() {
      this.watchTitle();
    },
    movedCount(to) {
      this.$refs.tabType.style.transform = `translateX(-${to * 90}px)`;
    },
    tabIndex(to) {
      console.log('watch tabIndex to', to)
      // 如果是人脸识别
      if (to == 3) {
        // 图片类型 完成
        if (this.detail.face_status - 0 === 3 && this.detail.type - 0 === 1) {
          this.getVideoDetail();
        }
        // // 图片类型 未提交
        // else if (this.detail.face_status - 0 === 1 && this.detail.type - 0 === 1) {
        //   this.picFaceRec();
        // }
        // // 视频类型 未提交
        // else if (this.detail.face_status - 0 === 1 && this.detail.type - 0 === 2) {
        //   this.videoFaceRec();
        // }
      }
      else {
        // this.picFaceList = [];
        // if (to == 2) {
        //   if (this.detail.text_status - 0 === 1) {
        //     this.convertWord(this.detail);
        //   }
        // }
      }
    },
    editText(to) {
      if (to) {
        if (this.textArea == "无") {
          this.textArea = "";
        }
      } else {
        if (this.textArea == "") {
          this.textArea = "无";
        } else {
          this.setInfoMaterial();
        }
      }
    }
  },
  methods: {
    showCard(id, e) {
      if (id == 0) return;

      const el = e.target;

      this.$card(id, el);
    },
    closecreate() {
      this.isShowCreate = false
    },
    closeDownload() {
      // console.log(123)
      this.isShowDownload = false
    },
    clickCreate() {
      this.isShowCreate = !this.isShowCreate
    },
    createdDownload() {
      this.isShowDownload = !this.isShowDownload
    },
    audioPlay(){
      this.$refs.audioDom.play();
      this.isPlay=true;
    },
    audioPause(){
      console.log(99999)
      this.$refs.audioDom.pause();
      this.isPlay=false;
    },
    setInfoMaterial() {
      let info = {
        idstring: this.detail.idstring,
        info: this.textArea
      };
      common.myFetch(apis.setInfoMaterial, info).then(r => {
        console.log(r);
        if (r) {
          this.$toast("修改成功");
        }
      });
    },
    prevClick() {
      if (this.$refs.videoDom) {
        this.$refs.videoDom.pause();
      }
      if (this.$refs.audioDom) {
        this.$refs.audioDom.pause();
      }
      let index = Number(this.nowIndex);
      this.picFaceList = []
      if (index > 0) {
        index--;
        this.nowIndex = index;
        this.getDetail(this.o.list[index].id, "click");
      }
    },
    nextClick() {
      if (this.$refs.videoDom) {
        this.$refs.videoDom.pause();
      }
      if (this.$refs.audioDom) {
        this.$refs.audioDom.pause();
      }
      let index = Number(this.nowIndex);
      let maxLength = this.o.list.length - 1;
      this.picFaceList = []
      if (index < maxLength) {
        index++;
        this.nowIndex = index;
        this.getDetail(this.o.list[index].id, "click");
      }
    },
    getVideoDetail() {
      const info = {
        idstring: this.detail.idstring
      };
      common.myFetch(apis.faceRes, info).then(r => {
        if (r) {
          if (this.detail.type - 0 === 1) {
            this.$set(this.detail, "face_status", 3);
            this.faceList = r;
            this.picFaceList = [];
            this.faceList.forEach(el => {
              this.$set(el, "status", false);
              if (el.position) {
                let posArr = el.position.split(",");
                let width1 =
                  (this.faceOriginWidth * parseInt(this.imgListHeight1)) /
                  this.faceOriginHeight;

                let height1 = parseInt(this.imgListHeight1);

                let top = 0;
                if (width1 > parseInt(this.imgListWidth1)) {
                  width1 = 650;

                  height1 =
                    (650 * this.faceOriginHeight) / this.faceOriginWidth;

                  top = (650 * this.faceOriginHeight) / this.faceOriginWidth;

                  top = (366 - top) / 2;
                }

                let halfW1 = (parseInt(this.imgListWidth1) - width1) / 2;
                this.picFaceList.push({
                  borderLeft:
                    halfW1 + (posArr[0] * width1) / this.faceOriginWidth,
                  borderTop:
                    (posArr[1] * height1) / this.faceOriginHeight + top,
                  borderWidth:
                    (width1 * (posArr[2] - posArr[0])) / this.faceOriginWidth,
                  borderHeight:
                    (height1 * (posArr[3] - posArr[1])) / this.faceOriginHeight
                });
              }
            });
          }

          else if (this.detail.type - 0 === 2) {
            this.$set(this.detail, "face_status", 3);
            this.videoFaceList = r;
            this.videoFaceList.forEach(el => {
              this.$set(el, "desStatus", false);
              this.$set(el, "picStatus", false);
              el.result.forEach(i => {
                let startTime = i.first_time.split(".")[0];
                let endTime = i.last_time.split(".")[0];
                this.$set(i, "first_time", startTime);
                this.$set(i, "last_time", endTime);
                if (i.face_rect) {
                  let posArr = i.face_rect.split(",");
                  let width1 =
                    (this.faceOriginWidth * parseInt(this.imgListHeight)) /
                    this.faceOriginHeight;
                  let halfW1 = (parseInt(this.imgListWidth) - width1) / 2;

                  i.borderLeft =
                    halfW1 + (posArr[0] * width1) / this.faceOriginWidth;
                  i.borderTop =
                    (posArr[1] * parseInt(this.imgListHeight)) /
                    this.faceOriginHeight;
                  i.borderWidth =
                    (width1 * (posArr[2] - posArr[0])) / this.faceOriginWidth;
                  i.borderHeight =
                    (parseInt(this.imgListHeight) * (posArr[3] - posArr[1])) /
                    this.faceOriginHeight;
                }
              });
            });
          }
        }
      });
    },
    changeSpeed(speed) {
      const video = this.$refs.videoDom;
      this.nowSpeed = speed;
      let multiple = 1;
      if (speed === "1x") {
        multiple = 1;
      } else if (speed === "2x") {
        multiple = 2;
      } else {
        multiple = 4;
      }
      video.playbackRate = multiple;
      this.showSelectList = false;
    },
    renameAsset() {
      if (!this.titleInput) return;
      const info = {
        idstring: this.detail.idstring,
        title: this.titleInput
      };

      common.myFetch(apis.File_rename, info).then(r => {
        if (r) {
          this.$toast(r);
          this.showInput = false;
          this.$set(this.detail, "title", this.titleInput);
          this.callback();
        }
      });
    },
    watchTitle() {
      let str = this.titleInput;
      this.getLength(str);
    },
    getLength(str) {
      let n = null;
      for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) >= 0 && str.charCodeAt(i) <= 256) {
          n += 0.5;
        } else {
          n += 1;
        }
      }

      if (n <= 40) {
        this.saveTitleInput = this.titleInput;
      } else {
        this.titleInput = this.saveTitleInput;
      }

      this.wordNum = Math.floor(n);
    },
    downloadSource(source, type) {
      if (type === 0) {
        if (!this.detail.has_low_quality_download_role) {
          this.$toast("无下载权限");
          return;
        } else {
          if (source.type != 1) {
            if (source.content.status != 1) {
              this.$toast("转码尚未完成");
              return;
            }
          }
        }
      } else if (type === 1) {
        if(this.detail.type == 1){
          if (!this.detail.has_high_quality_download_role&&!this.detail.has_low_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }else if(this.detail.type == 3) {
          if (!this.detail.has_high_quality_download_role&&!this.detail.has_low_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }else{
          if (!this.detail.has_high_quality_download_role) {
            this.$toast("无下载权限");
            return;
          }
        }
      }

      const info = {
        idstring: source.idstring,
        file_quality: type || 0
        // subject_type: 0,
        // subject_id: this.$route.query.d
      };
      const url = apis.File_download;
      const userKeys = common.userKeys();
      const params = Object.assign({}, info, userKeys);

      common.exportRes(url, params, 1);
    },
    faceRec() {
      if (this.detail.type - 0 === 1) {
        this.picFaceRec();
      } else if (this.detail.type - 0 === 2) {
        this.videoFaceRec();
      }
    },
    /**
     * 通知技审结果变化
     */
    getVideoAudit(msg) {
      console.log('通知技审结果变化 getVideoAudit', msg)
      let { content: { id, pickup } } = msg.content
      console.log('id', id)
      console.log('pickup', pickup)
      if (id == this.detail.id) {
        this.$toast(pickup);
        this.getDetail(id)
      }
    },
    /**
     * 提交 视频技审
     */
    videoAudit() {
      const info = {
        idstring: this.detail.idstring,
      };
      this.submitVideoAuditing = true
      common.myFetch(apis.videoAudit, { data: info, hideLoading: true }).then(r => {
        this.submitVideoAuditing = false
        if (r) {
          // 状态变成loading 处理中
          this.detail.audit_status = 2
        }
      })
    },
    /**
     * 照片 人脸识别
     */
    picFaceRec() {
      const info = {
        idstring: this.detail.idstring
      };
      this.$set(this.detail, "face_status", 2);
      common.myFetch(apis.imgface, info).then(r => {
        if (r) {
          this.$set(this.detail, "face_status", 3);
          this.faceList = r;
          this.picFaceList = [];
          this.faceList.forEach(el => {
            this.$set(el, "status", false);
            if (el.position) {
              let posArr = el.position.split(",");
              let width1 =
                (this.faceOriginWidth * parseInt(this.imgListHeight1)) /
                this.faceOriginHeight;

              let height1 = parseInt(this.imgListHeight1);

              let top = 0;

              if (width1 > parseInt(this.imgListWidth1)) {
                console.log('进入》分支')
                width1 = 650;

                height1 =
                  (650 * this.faceOriginHeight) / this.faceOriginWidth;

                top = (650 * this.faceOriginHeight) / this.faceOriginWidth;

                top = (366 - top) / 2;
              }

              let halfW1 = (parseInt(this.imgListWidth1) - width1) / 2;
              this.picFaceList.push({
                borderLeft:
                  halfW1 + (posArr[0] * width1) / this.faceOriginWidth,
                borderTop:
                  (posArr[1] * height1) / this.faceOriginHeight + top,
                borderWidth:
                  (width1 * (posArr[2] - posArr[0])) / this.faceOriginWidth,
                borderHeight:
                  (height1 * (posArr[3] - posArr[1])) / this.faceOriginHeight
              });
            }
          });
        } else {
          this.$set(this.detail, "face_status", 4);
        }
      });
    },
    /**
     * 视频人脸识别
     */
    videoFaceRec() {

      const info = {
        idstring: this.detail.idstring
      };

      common.myFetch(apis.faceRec, info).then(r => {
        if (r) {
          this.$set(this.detail, "face_status", 2);
          this.$toast(r);
        }else{
          this.$set(this.detail, "face_status", 4);
        }
      });
    },
    test() {
      if (this.callback) {
        this.callback();
      }
    },
    edit(type) {
      if (type - 0 === 1) {
        this.editPic(this.detail);
      } else if (type - 0 === 2) {
        let info = {
          title: this.detail.title,
          id: this.detail.id
        }
        this.$cloudEditConfirm(info).then((res) => {
          if(res != 999){
            window.open(res.meisheurl)
          }
        })
        // console.log(this.detail)
      } else if (type - 0 === 3) {
        this.editVideo(this.detail.text_status, this.detail);
      }
    },
    editVideo(i, j) {
      console.log(i, j);
      let newObj = {
        pageType: null,
        pageId: null,
        file_format: this.detail.upload.url,
        appId: this.detail.upload.app_id,
        appSecret: this.detail.upload.app_secret
      };
      Object.assign(j, newObj);
      this.$voiceEditType(i, j).then(res => {
        console.log(res, i);
        console.log(this.t,this.d)
        if (res == 0 && i == 3 && res !== false) {
          // console.log(this.pageType,this.$route.query.d,j)
          const newWindow = window.open();
          // console.log(`${window.location.origin}/voiceEdit/${this.pageType}/${this.$route.query.d}/${j.idstring}`)
          newWindow.location.href = `${window.location.origin
            }/voiceEdit/${this.t}/${this.d}/${j.idstring
            }`;
        } else if (res == "peComplete") {
          this.test();
        }
      });
    },
    editPic(i) {
      if (this.t == null && this.d == null) {
        i.t = null;
        i.d = this.detail.id;
      } else {
        i.t = this.t;
        i.d = this.d;
      }
      this.$picEditType1(i, this.test).then(el => {
        console.log(el)
        if (Number(el) == '123') {
          console.log(true)
          store.commit('setflashPic1', true)
        }
      });
    },
    copyText() {
      if (this.wordList.length === 0) return false;
      const wordListDom = this.$refs.wordList;
      wordListDom.value = this.wordContent;
      wordListDom.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      this.$toast("复制成功");
    },
    beforeunload_normal(e) {
      console.log("beforeunload_normal", e);
      const event = e || window.event;
      return (event.returnValue = true);
    },
    exportText() {
      if (this.wordList.length === 0) return false;
      const info = {
        idstring: this.detail.idstring,
        type: 2
      };

      info.paragraphs = this.wordList
        .filter(i => i.selected)
        .map(j => j.o)
        .join(",");

      const userKeys = common.userKeys();
      const params = Object.assign({}, info, userKeys);

      window.removeEventListener(
        "beforeunload",
        this.beforeunload_normal
      )

      common.exportRes(apis.File_expTxt, params);
    },
    getWordList() {
      // console.log(this.detail.idstring)
      // this.$set(this.detail, "text_status", 3);
      const info = {
        idstring: this.detail.idstring
      };

      common.myFetch(apis.File_getWord, info).then(r => {
        if (r) {
          // 获取接口
          // this.detail.text_status = 3;
          this.$set(this.detail, "text_status", 3);
          this.wordContent = r.content;
          this.wordList = r.res;
          this.wordList.forEach((i, d) => {
            i.o = d;
            i.selected = true;
          });
          this.$set(this.detail, "text_status", 3);

          console.log(this.detail.text_status)
        }
      });
    },
    getTranstext(r) {
      console.log('getTranstext r', r)
      // 获取转文字状态
      this.$toast("转文字完成");
      this.detail.text_status = 3;
      // this.getDetail();
      this.getWordList();
    },
    convertWord(f) {
      // 音视频转文字
      if ((!f.content || f.content.status != 1) && f.type != 3) {
        this.$toast("转码中，暂时无法转文字");
        return;
      }

      const info = {
        idstring: f.idstring
      };

      common.myFetch(apis.File_convert, info).then(r => {
        if (r) {
          this.$toast(r);

          this.$set(f, "text_status", 2);
        }
      });
    },
    useDetail() {
      let data = {
        file_ids: this.detail.id
      };

      common.myFetch(apis.File_addquickfile, data).then(res => {
        if (res) {
          this.$toast("已成功加入选用素材");
          store.commit("setQuickEditNum", res.quick_edit_num);
        }
      });
    },
    async navigate(type, id) {
      if (type === "material") {
        let info = {
          id: id,
          push_to: type,
          type: 0
        };
        common.myFetch(apis.File_filepush, info).then(r => {
          if (r) {
            common.jump(`/creatClue?t=0&d=${r.id}`, true);
          }
        });
      } else if (type === "report") {
        const typeName = await this.$pageType();
        if (!typeName) return;
        let info = {
          id: id,
          push_to: type,
          type: typeName
        };
        common.myFetch(apis.File_filepush, info).then(r => {
          if (r) {
            common.jump(`/creatReport?t=${typeName}&d=${r.id}`, true);
          }
        });
      } else if (type === "publish") {
        const typeName = await this.$pageType("publish");
        if (!typeName) return;
        let info = {
          id: id,
          push_to: type,
          type: typeName
        };
        common.myFetch(apis.File_filepush, info).then(r => {
          if (r) {
            common.jump(`/createPublish?t=${typeName}&d=${r.id}`, true);
          }
        });
      }
    },
    leftClick() {
      // tab栏最多显示3个
      if (this.tabList.length <= 3 || this.movedCount < 1) return;

      this.movedCount--;
      this.$refs.tabType.style.transform = `translateX(-${this.movedCount *
        90}px)`;
    },
    rightClick() {
      // tab栏最多显示3个
      let index = this.movedCount + 3;

      if (index < this.tabList.length) {
        this.movedCount++;
        this.$refs.tabType.style.transform = `translateX(-${this.movedCount *
          90}px)`;
      }
    },
    clickJump(e) {
      let clientX = this.$refs.line.getBoundingClientRect().x;
      let width = 596;
      let left = 0;
      let percent = 0;

      if (e.clientX - clientX <= 0) {
        left = "0%";
      } else if (e.clientX - clientX >= 596) {
        left = "100%";
      } else {
        percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
        left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
      }

      this.percent = percent;
      this.audioPercent = left;

      // this.$refs.sliderLeft.style.width = left;

      this.timeNavi();

      this.isMouseClick = false;
    },
    timeNavi() {
      if (this.isMouseClick) {
        let percent = this.percent / 100;
        let time = (percent * this.duration).toFixed(2);
        this.$refs.audioDom.currentTime = time;
        this.$refs.audioDom.play();
        this.isPlay = true;
        this.isMouseClick = false;
      }
    },
    timeStop() {
      this.isPlay = false;
      this.$refs.audioDom.pause();
    },
    slideMouseMove(e) {
      // return false;
      if (this.isMouseClick) {
        let clientX = this.$refs.line.getBoundingClientRect().x;
        let width = 596;
        let left = 0;
        let percent = 0;

        if (e.clientX - clientX <= 0) {
          left = "0%";
        } else if (e.clientX - clientX >= 596) {
          left = "100%";
        } else {
          percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
          left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
        }

        this.nowTime = this.s2hms(
          (this.$refs.audioDom.duration * percent) / 100
        );

        this.percent = percent;
        this.audioPercent = left;

        // this.$refs.sliderLeft.style.width = left;
      }
    },
    audioLoad() {
      let that = this;
      that.duration = parseInt(that.$refs.audioDom.duration);
      that.endTime = that.s2hms(parseInt(that.$refs.audioDom.duration));
      console.log(that.$refs.audioDom.duration,that.endTime)
      if(isNaN(that.$refs.audioDom.duration)){
        that.endTime = '00:00:00'
      }
      that.nowTime = that.s2hms(parseInt(that.$refs.audioDom.currentTime));
      if(isNaN(that.nowTime)){
        that.nowTime = '00:00:00'
      }
      let percent =
        (
          (parseInt(that.$refs.audioDom.currentTime) /
            parseInt(that.$refs.audioDom.duration)) *
          100
        ).toFixed(2) + "%";
      that.audioPercent = percent;

      this.$refs.audioDom.play();
      this.isPlay = true;

      this.$refs.audioDom.ontimeupdate = function (e) {
        that.nowTime = that.s2hms(parseInt(e.target.currentTime));
        let percent =
          (
            (parseInt(e.target.currentTime) / parseInt(e.target.duration)) *
            100
          ).toFixed(2) + "%";
        that.audioPercent = percent;
      };

      this.$refs.audioDom.onended = function () {
        that.isPlay = false;
      };
    },
    open(c, r, call, o) {
      // document.body.style.overflow = "hidden";
      store.commit("setflashPic1", false);
      this.r = r;
      this.callback = call;

      if (o) {
        this.o = o;
        this.canEdit = o.canEdit || false;
        this.create = o.create;
        this.quickEdit = o.quickEdit;
        this.nowIndex = this.o.index;
        this.tabIndex = o.tabIndex || this.tabIndex;
        this.maxIndex = this.o.list.length - 1;
        this.t = o.t;
        this.d = o.d;
        console.log(this.o)
        this.getDetail(this.o.list[this.o.index].id);
      } else {
        this.config = c;
        this.canEdit = c.canEdit || false;
        this.create = c.create;
        this.tabIndex = c.tabIndex || this.tabIndex;
        console.log("open c", c);
        this.quickEdit = c.quickEdit;
        this.t = c.t;
        this.d = c.d;
        this.getDetail(this.config.id);
      }
      this.show = true;

      this.$nextTick(() => {
        this.disableContextMenu()
      })
    },
    disableContextMenu() {
      // 隐藏右键菜单
      if(this.$refs.imgDom){
        this.$refs.imgDom.oncontextmenu = function(event) {
          return false
        }
      }

      if(this.$refs.videoDom){
        this.$refs.videoDom.oncontextmenu = function(event) {
          return false
        }
      }

      if(this.$refs.audioDom){
        this.$refs.audioDom.oncontextmenu = function(event) {
          return false
        }
      }
    },
    close() {
      // document.body.style.overflow = "auto";
      if (this.$refs.videoDom) {
        this.$refs.videoDom.pause();
      }
      if (this.$refs.audioDom) {
        this.$refs.audioDom.pause();
      }
      this.show = false;
      store.commit("setScrollHide", false);
    },
    s2hms(time) {
      let min = Math.floor(time % 3600);
      let hh =
        Math.floor(time / 3600) < 10
          ? "0" + Math.floor(time / 3600)
          : Math.floor(time / 3600);
      let mm =
        Math.floor(min / 60) < 10
          ? "0" + Math.floor(min / 60)
          : Math.floor(min / 60);
      let ss = time % 60 < 10 ? "0" + parseInt(time % 60) : parseInt(time % 60);
      return hh + ":" + mm + ":" + ss;
      // console.log(hh + ":" + mm + ":"+ ss)
    },
    /**
     * id 素材的id
     * hint 如果通过左右切换素材 是click
     */
    getDetail(id, hint) {
      console.log('getDetail id', id)
      // 获取详情接口
      return common.myFetch(apis.file_detail, { id }).then(r => {
        if (r) {
          this.detail = r.detail;
          console.log('getDetail r', r);

          this.titleInput = this.detail.title;
          this.saveTitleInput = this.detail.title;
          if (this.detail.info) {
            this.textArea = this.detail.info;
          }
          if(this.detail.type==2){
            setTimeout(() => {
              this.$refs.videoDom.play();
            }, 500);
            
          }
          // type。图片是1.视频是2.音频是3
          // 如果是图片
          if (this.config.type - 0 === 1) {
            if (this.detail.has_face_rec) {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 },
                { name: "人脸识别", index: 3 }
              ];
            } else {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 }
              ];
            }
          }
          // 如果是视频
          else if (this.config.type - 0 === 2) {
            if (this.detail.has_face_rec && this.detail.has_pickup_text_role) {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 },
                { name: "语音识别", index: 2 },
                { name: "人脸识别", index: 3 }
              ];
            } else if (
              this.detail.has_face_rec == false &&
              this.detail.has_pickup_text_role
            ) {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 },
                { name: "语音识别", index: 2 }
              ];
            } else if (
              this.detail.has_face_rec &&
              this.detail.has_pickup_text_role == false
            ) {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 },
                { name: "人脸识别", index: 3 }
              ];
            }
            else {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 }
              ];
            }
          }
          // 如果是音频
          else if (this.config.type - 0 === 3) {
            if (this.detail.has_pickup_text_role) {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 },
                { name: "语音识别", index: 2 }
              ];
            } else {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 }
              ];
            }
          } else if (this.detail.type - 0 === 1) {
            if (this.detail.has_face_rec) {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 },
                { name: "人脸识别", index: 3 }
              ];
            } else {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 }
              ];
            }
          }
          // 文件类型 视频
          else if (this.detail.type - 0 === 2) {
            if (this.detail.has_face_rec && this.detail.has_pickup_text_role) {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 },
                { name: "语音识别", index: 2 },
                { name: "人脸识别", index: 3 }
              ];
            } else if (
              this.detail.has_face_rec == false &&
              this.detail.has_pickup_text_role
            ) {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 },
                { name: "语音识别", index: 2 }
              ];
            } else if (
              this.detail.has_face_rec &&
              this.detail.has_pickup_text_role == false
            ) {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 },
                { name: "人脸识别", index: 3 }
              ];
            } else {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 }
              ];
            }
          }
          // 文件类型 音频
          else if (this.detail.type - 0 === 3) {
            if (this.detail.has_pickup_text_role) {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 },
                { name: "语音识别", index: 2 }
              ];
            }
            // 文件类型 图片
            else {
              this.tabList = [
                { name: "详情", index: 0 },
                { name: "标签", index: 1 }
              ];
            }
          }

          // 添加视频技审模块。视频类型 且 技审模块开启
          if (+this.detail.type == 2 && this.detail.audit_exists) {
            this.tabList.push({
              name: "技术审核",
              index: 4
            });
          }
          // 如果是通过左右点击切换素材，tabIndex回到0
          if (hint === "click") {
            this.tabIndex = 0;
          }
          // 根据传进来的tabIndex
          let index = this.tabList.findIndex(e => e.index == this.tabIndex);
          this.movedCount = index + 1 - 3 > 0 ? index + 1 - 3 : 0;

          if (r.detail.tags) {
            this.tagList = r.detail.tags.split(",");
          }

          if (r.detail && r.detail.content && r.detail.content.resolution) {
            let resolution = r.detail.content.resolution.split("x");
            this.faceOriginWidth = Number(resolution[0]);
            this.faceOriginHeight = Number(resolution[1]);
          }

          if (r.detail && r.detail.content && r.detail.content.pixel) {
            let resolution = r.detail.content.pixel.split("*");
            this.faceOriginWidth = Number(resolution[0]);
            this.faceOriginHeight = Number(resolution[1]);
          }

          if (r.detail.text_status - 0 === 3) {
            this.getWordList();
          }

          if (r.detail.face_status - 0 === 3 && r.detail.type - 0 === 2) {
            this.getVideoDetail();
          }

          if (
            r.detail.face_status - 0 === 3 &&
            r.detail.type - 0 === 1 &&
            this.tabIndex == 3
          ) {
            this.getVideoDetail();
          }

          if (this.detail.type - 0 === 3) {
            setTimeout(() => {
              this.audioLoad();
            }, 300);
          }
        }
      });
    },
    addTag() {
      // if (!this.canEdit) return false;
      const info = {
        idstring: this.detail.idstring,
        tag: this.tagInput
      };

      if (this.tagInput) {
        common.myFetch(apis.File_addTag, info).then(r => {
          if (r) {
            console.log(r);
            let tagList = this.tagList;
            tagList.push(this.tagInput);
            tagList = Array.from(new Set(tagList));
            this.tagList = tagList;
            this.$toast("添加标签成功");
            // this.tagList.push(this.tagInput);
            this.tagInput = null;
          }
        });
      }
    },
    delTag(index) {
      const info = {
        idstring: this.detail.idstring,
        tag: this.tagList[index]
      };

      common.myFetch(apis.File_delTag, info).then(r => {
        if (r) {
          this.$toast("删除标签成功");
          this.tagList.splice(index, 1);
        }
      });
    },
    // confirm() {
    //   this.r(true)
    //   this.close()
    // },
    alpha() {
      this.config.alpha.handle();
      this.r(true);
      this.close();
    },
    beta() {
      this.config.beta.handle();
      this.r(true);
      this.close();
    },
    cancel() {
      this.r(false);
      this.close();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
  position: relative;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1008;

  .next,
  .prev {
    position: absolute;
    top: 50%;
    margin-top: -17.5px;
    width: 35px;
    height: 35px;
    background: url("../../assets/img/common/img-next.svg") no-repeat;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;

    &.on {
      background: url("../../assets/img/common/img-next-un.svg") no-repeat;
    }
  }

  .prev {
    transform: rotate(-180deg);
    left: calc(((100vw - 1100px) / 2) / 2);
  }

  .next {
    right: calc(((100vw - 1100px) / 2) / 2);
  }

  .materialBox-container {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 1040px;
    height: 539px;
    border-radius: 4px;
    background-color: #ebf0f5;
    box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
    padding: 22px 30px 0;
    box-sizing: border-box;
    // overflow: hidden;
    .verify-logo {
      width: 22px;
      margin-right: 10px;
      cursor: auto !important;
    }
    .close {
      position: absolute;
      top: 20px;
      right: 30px;
      user-select: none;
      cursor: pointer;
    }

    .title {
      display: flex;
      // display: none;
      flex-direction: row;
      align-items: center;
      margin-bottom: 22px;
      font-weight: bold;

      p {
        max-width: 914px;
        font-size: 22px;
        line-height: 29px;
        color: #050f0f;
        margin-right: 10px;
      }

      img {
        user-select: none;
        cursor: pointer;
      }
    }

    .titleInput {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 914px;
      padding-bottom: 5.5px;
      border-bottom: 1px solid #dcdcdc;
      box-sizing: border-box;
      margin-bottom: 15.5px;

      .input {
        display: flex;
        flex-direction: row;
        align-items: center;

        input {
          width: 860px;
          height: 29px;
          line-height: 29px;
          font-size: 22px;
          color: #050f0f;
          background: transparent;
          border: none;
          outline: none;
        }

        span {
          display: block;
          width: 2px;
          height: 14px;
          background: #b9c3c3;
          margin-left: 1px;
        }
      }

      .wordNumber {
        font-size: 14px;
        color: #b9c3c3;
        font-weight: bold;
        font-family: Arial;
      }
    }

    .content-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .media-container {
        position: relative;
        width: 650px;
        height: 366px;
        background-color: #f9f9f9;
        box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);

        .video {
          position: relative;
          width: 100%;
          height: 100%;

          video {
            width: 100%;
            height: 100%;
            background: #000;
          }

          .speedRate {
            position: absolute;
            top: 14px;
            right: 14px;

            .btn {
              display: flex;
              flex-direction: row;
              justify-content: center;
              align-items: center;
              width: 62px;
              height: 30px;
              border-radius: 15px;
              background: rgba(0, 0, 0, 0.3);
              user-select: none;
              cursor: pointer;

              span {
                display: block;
                font-size: 16px;
                line-height: 30px;
                color: #fff;
              }

              img {
                margin-left: 4px;
              }
            }

            .btnList {
              display: flex;
              flex-direction: column;

              p {
                height: 10px;
              }

              ul {
                display: flex;
                flex-direction: column;
                border-radius: 4px;
                overflow: hidden;
                background: rgba(0, 0, 0, 0.3);

                li {
                  width: 100%;
                  height: 30px;
                  line-height: 30px;
                  text-align: center;
                  font-size: 16px;
                  color: #fff;
                  user-select: none;
                  cursor: pointer;

                  &:hover {
                    background: rgba(0, 0, 0, 0.5);
                  }
                }
              }
            }
          }
        }

        .img {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
          background-color: #000;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;

          .border {
            position: absolute;
            top: 0;
            left: 0;
            border: 2px solid #ff555a;
            border-radius: 6px;
            box-sizing: border-box;

            i {
              position: absolute;
              top: -10px;
              left: -10px;
              display: block;
              width: 20px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              font-size: 14px;
              color: #fff;
              border-radius: 50%;
              background-color: #ff4153;
            }
          }
        }

        .audio {
          width: 100%;
          height: 100%;
          background: #f9f9f9;

          audio {
            display: none;
          }

          .control {
            position: relative;
            width: 199px;
            margin: 0 auto 0;
            padding-top: 84px;
            box-sizing: border-box;
            margin-bottom: 21px;

            .play {
              position: absolute;
              top: 50%;
              left: 50%;
              margin-left: -32px;
              margin-top: 0px;
              user-select: none;
              cursor: pointer;
            }

            .pause {
              position: absolute;
              top: 50%;
              left: 50%;
              margin-left: -12px;
              margin-top: 22px;
              user-select: none;
              cursor: pointer;
            }
          }

          .progress-container {
            display: flex;
            flex-direction: column;
            width: 598px;
            margin: 0 auto;

            .time {
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
              font-size: 13px;
              line-height: 15px;
              color: #829191;
              font-weight: bold;
              font-family: Arial;
              margin-bottom: 8px;

              span {
                display: block;
              }

              .grey {
                color: #b9c3c3;
              }
            }

            .progress {
              position: relative;
              width: 596px;
              user-select: none;

              .progress-bg {
                position: absolute;
                top: 0;
                left: 0;
                width: 596px;
                height: 3px;
                border-radius: 1.5px;
                background-color: rgba(151, 151, 151, 0.2);
              }

              .progress-fill {
                position: absolute;
                top: 0;
                left: 0;
                width: 0%;
                height: 3px;
                border-radius: 1.5px;
                background-color: @green;

                i {
                  position: absolute;
                  top: 50%;
                  right: -7px;
                  margin-top: -7px;
                  display: block;
                  width: 14px;
                  height: 14px;
                  border-radius: 50%;
                  background: #fff;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }

      .detail-container {
        display: flex;
        flex-direction: column;
        width: 320px;
        height: 366px;
        border-radius: 4px;
        background: #f9f9f9;
        box-shadow: 4px 4px 10px 0 rgba(5, 10, 15, 0.05);
        overflow: hidden;

        .tab-list {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 50px;
          box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);

          .tabType {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 270px;
            overflow: hidden;

            ul {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              transition: all 0.5s;
              li {
                position: relative;
                min-width: 90px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                user-select: none;
                cursor: pointer;
                font-weight: bold;

                &:nth-last-of-type(1) {
                  &:after {
                    display: none;
                  }
                }

                &:after {
                  position: absolute;
                  top: 50%;
                  right: -0.5px;
                  margin-top: -9px;
                  content: "";
                  display: block;
                  width: 1px;
                  height: 18px;
                  background: #dcdcdc;
                }

                &.on {
                  color: @green;
                  border-bottom: 2px solid @green;
                  box-sizing: border-box;
                }
              }
            }
          }

          .btn {
            display: flex;
            flex-direction: row;
            align-items: center;

            .leftArrow {
              width: 11px;
              height: 15px;
              background: url("../../assets/img/material/leftArrow.svg")
                no-repeat;
              background-position: center;
              background-size: 100% 100%;
              margin-right: 10px;
              user-select: none;
              cursor: pointer;

              &.on {
                width: 11px;
                height: 15px;
                background: url("../../assets/img/material/leftArrowOn.svg")
                  no-repeat;
                background-position: center;
                background-size: 100% 100%;
              }
            }

            .rightArrow {
              width: 11px;
              height: 15px;
              background: url("../../assets/img/material/rightArrow.svg")
                no-repeat;
              background-position: center;
              background-size: 100% 100%;
              margin-right: 10px;
              user-select: none;
              cursor: pointer;

              &.on {
                width: 11px;
                height: 15px;
                background: url("../../assets/img/material/rightArrowOn.svg")
                  no-repeat;
                background-position: center;
                background-size: 100% 100%;
              }
            }
          }
        }

        .detail {
          display: flex;
          flex-direction: column;
          width: 100%;
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 4px;
          }

          & > div {
            &:hover {
              // background: rgba(185,195,195,0.15);
            }
          }

          .userInfo {
            padding: 16px 20px 0px;

            p {
              display: flex;
              flex-direction: row;
              align-items: center;
              width: 100%;
              font-size: 14px;
              line-height: 18px;
              color: #b9c3c3;

              &.name {
                cursor: pointer;
              }

              span {
                margin-left: 10px;
                font-weight: bold;
              }

              &.name {
                margin-bottom: 8px;
              }

              &.clock {
                font-weight: bold;
                font-family: Arial;
                padding-bottom: 8px;
                border-bottom: 1px solid #dcdcdc;
                box-sizing: border-box;
              }
            }
          }

          .info {
            display: flex;
            flex-direction: column;
            padding: 12px 20px;
            box-sizing: border-box;

            &.format {
              background: rgba(185, 195, 195, 0.15);
              div {
                span {
                  font-weight: bold;
                }

                &:nth-last-of-type(1) {
                  margin-bottom: 0px;
                }
              }
            }

            div {
              display: flex;
              flex-direction: row;
              align-items: center;
              margin-bottom: 12px;

              &:nth-last-of-type(1) {
                margin-bottom: 0;
              }

              p {
                min-width: 26px;
                font-size: 13px;
                line-height: 17px;
                color: #b9c3c3;
                margin-right: 10px;
              }

              span {
                display: block;
                font-size: 14px;
                line-height: 18px;
                color: #829191;
                word-break: break-all;
                font-weight: bold;
              }
            }
          }

          .sum {
            display: flex;
            flex-direction: column;
            padding: 12px 20px;
            box-sizing: border-box;

            div {
              display: flex;
              flex-direction: row;
              margin-bottom: 12px;

              &:nth-last-of-type(1) {
                margin-bottom: 0;
              }

              p {
                min-width: 26px;
                font-size: 13px;
                line-height: 17px;
                color: #b9c3c3;
                margin-right: 10px;
              }

              span {
                min-height: 68px;
                font-size: 14px;
                line-height: 18px;
                color: #829191;
                word-break: break-all;
                font-weight: bold;
              }

              .editIcon {
                width: 19px;
                height: 22px;
                vertical-align: middle;
                margin-left: 10px;
                user-select: none;
                cursor: pointer;
              }

              .textArea {
                position: relative;
                width: 244px;
                height: 100px;
                border-radius: 4px;
                background-color: rgba(185, 195, 195, 0.2);
                padding: 8px 10px;
                box-sizing: border-box;

                span {
                  position: absolute;
                  bottom: 8px;
                  right: 12px;
                  font-size: 14px;
                  line-height: 18px;
                  color: @green;
                  min-height: 18px;
                  user-select: none;
                  cursor: pointer;
                }

                textarea {
                  font-size: 16px;
                  line-height: 21px;
                  color: #050f0f;
                  width: 100%;
                  height: 100%;
                  background: transparent;
                  border: none;
                  outline: none;
                  resize: none;

                  &::-webkit-scrollbar {
                    width: 4px;
                  }
                  &::-webkit-scrollbar-thumb {
                    background: #ddd;
                    border-radius: 4px;
                  }
                }
              }
            }
          }
        }

        .tab {
          display: flex;
          flex-direction: column;
          width: 100%;
          padding: 16px 20px 0;
          box-sizing: border-box;
          overflow-y: auto;

          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-thumb {
            background: #ddd;
            border-radius: 4px;
          }

          .empty {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 80px;

            img {
              margin-bottom: 20px;
            }

            span {
              font-size: 16px;
              line-height: 21px;
              color: #b9c3c3;
            }
          }

          .input {
            display: flex;
            align-items: center;
            width: 100%;
            min-height: 40px;
            padding: 0px 20px 0;
            border-radius: 4px;
            background-color: rgba(185, 195, 195, 0.2);
            box-sizing: border-box;
            overflow: hidden;

            input {
              width: 100%;
              font-size: 14px;
              line-height: 18px;
              color: #050f0f;
              background: transparent;
              outline: none;
              border: none;

              &::placeholder {
                color: #b9c3c3;
              }
            }
          }

          ul {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            margin-top: 20px;

            li {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              min-height: 30px;
              line-height: 30px;
              color: #050f0f;
              border-radius: 4px;
              background: rgba(185, 195, 195, 0.2);
              padding: 0 10px 0 16px;
              margin-right: 10px;
              margin-bottom: 10px;
              box-sizing: border-box;

              &.on {
                padding: 0 16px;
                box-sizing: border-box;

                img {
                  display: none;
                }
              }

              span {
                word-break: break-all;
              }

              img {
                margin-left: 16px;
                user-select: none;
                cursor: pointer;
              }
            }
          }
        }

        .voiceRec-container {
          display: flex;
          flex-direction: column;
          margin-top: 16px;

          .btn {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 20px;
            box-sizing: border-box;

            p {
              display: flex;
              flex-direction: row;
              justify-content: center;
              width: 88px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              border-radius: 4px;
              font-size: 14px;
              color: @green;
              border: 1px solid @green;
              box-sizing: border-box;
              user-select: none;
              cursor: pointer;
              &.loading {
                cursor: unset;
              }
              &.green {
                background: @green;
                color: #fff;
              }
            }
          }

          .empty {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 80px;

            img {
              margin-bottom: 20px;
            }

            span {
              font-size: 16px;
              line-height: 21px;
              color: #b9c3c3;
            }
          }

          ul {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 260px;
            margin-top: 10px;
            overflow-y: auto;

            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-thumb {
              background: #ddd;
              border-radius: 4px;
            }

            li {
              display: flex;
              flex-direction: row;
              // justify-content: space-between;
              align-items: baseline;
              // min-height: 84px;
              background: rgba(185, 195, 195, 0.2);
              padding: 10px 20px 10px 17px;
              box-sizing: border-box;

              .time {
                font-size: 13px;
                line-height: 15px;
                min-width: 51px;
                color: #829191;
                font-family: Arial;
                margin-right: 10px;
              }

              p {
                font-size: 14px;
                line-height: 21px;
                color: #050f0f;
                word-break: break-all;
              }

              &:nth-of-type(even) {
                background: #f9f9f9;
              }
            }
          }
        }

        .faceRec-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 316px;
          // padding: 0 0 0 20px;
          box-sizing: border-box;

          .empty {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top: 80px;

            img {
              margin-bottom: 20px;
            }

            span {
              font-size: 16px;
              line-height: 21px;
              color: #b9c3c3;
            }
          }

          .recBtn {
            display: flex;
            justify-content: center;
            flex-direction: row;
            width: 280px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: @green;
            font-size: 14px;
            color: #fff;
            border-radius: 4px;
            user-select: none;
            cursor: pointer;
            margin-top: 16px;

            &.on {
              background: #fff;
              color: @green;
              border: 1px solid @green;
              box-sizing: border-box;
            }
          }

          ul.pic {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            // padding-right: 20px;
            padding: 0 20px 0 20px;
            box-sizing: border-box;

            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-thumb {
              background: #ddd;
              border-radius: 4px;
            }

            li {
              display: flex;
              flex-direction: column;
              margin-top: 16px;

              &:nth-last-of-type(1) {
                margin-bottom: 8px;
              }

              & > .name {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 10px;
                border-bottom: 1px solid #dcdcdc;
                box-sizing: border-box;

                .left-container {
                  display: flex;
                  flex-direction: row;
                  align-items: center;

                  .sensitive {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 62px;
                    height: 62px;
                    border-radius: 50%;
                    background: rgba(255, 85, 90, 0);
                    margin-right: 20px;
                    margin-left: 6px;

                    &.on {
                      background: rgba(255, 85, 90, 0.2);
                    }

                    .sensitiveBorder {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 56px;
                      height: 56px;
                      border-radius: 50%;
                      background: rgba(255, 85, 90, 0);

                      &.on {
                        background: rgba(255, 85, 90, 0.5);
                      }
                    }
                  }

                  .img {
                    position: relative;
                    width: 50px;
                    height: 50px;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    border-radius: 50%;

                    .num {
                      position: absolute;
                      left: -10px;
                      width: 20px;
                      height: 20px;
                      line-height: 20px;
                      text-align: center;
                      border-radius: 50%;
                      background: #ff4153;
                      font-size: 14px;
                      color: #fff;
                    }
                  }

                  .name {
                    font-size: 18px;
                    line-height: 24px;
                    font-weight: bold;
                    color: #050f0f;
                  }
                }

                .right-container {
                  display: flex;
                  flex-direction: row;
                  align-items: center;

                  span {
                    font-size: 14px;
                    line-height: 18px;
                    color: #829191;
                    margin-right: 10px;
                  }

                  img {
                    user-select: none;
                    cursor: pointer;

                    &.on {
                      transform: rotate(180deg);
                    }
                  }
                }
              }

              .isSensitive {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 62px;
                height: 18px;
                line-height: 18px;
                text-align: center;
                background: rgba(255, 85, 90, 0.1);
                border-radius: 2px;
                border: 1px solid #ff555a;
                font-size: 12px;
                color: #ff555a;
                margin-top: 9px;
              }

              .description {
                font-size: 14px;
                line-height: 21px;
                color: #050f0f;
                padding: 9.5px 0 9.5px;
                border-bottom: 1px solid #dcdcdc;
                box-sizing: border-box;
              }
            }
          }

          ul.video {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow-y: auto;
            // padding: 0 20px 0 20px;
            margin-top: 14px;
            box-sizing: border-box;

            &::-webkit-scrollbar {
              width: 4px;
            }
            &::-webkit-scrollbar-thumb {
              background: #ddd;
              border-radius: 4px;
            }

            li {
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-top: 16px;
              width: 100%;

              &:nth-last-of-type(1) {
                margin-bottom: 8px;
              }

              & > .name {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 9px;
                box-sizing: border-box;
                width: 280px;

                .left-container {
                  display: flex;
                  flex-direction: row;
                  align-items: center;

                  .sensitive {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 62px;
                    height: 62px;
                    border-radius: 50%;
                    background: rgba(255, 85, 90, 0);
                    margin-right: 20px;
                    // margin-left: 6px;

                    &.on {
                      background: rgba(255, 85, 90, 0.2);
                    }

                    .sensitiveBorder {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      width: 56px;
                      height: 56px;
                      border-radius: 50%;
                      background: rgba(255, 85, 90, 0);

                      &.on {
                        background: rgba(255, 85, 90, 0.5);
                      }
                    }
                  }

                  .img {
                    position: relative;
                    width: 50px;
                    height: 50px;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    border-radius: 50%;
                    // margin-right: 20px;

                    .num {
                      position: absolute;
                      width: 20px;
                      height: 20px;
                      line-height: 20px;
                      text-align: center;
                      border-radius: 50%;
                      background: #ff4153;
                      font-size: 14px;
                      color: #fff;
                    }
                  }

                  .name {
                    font-size: 18px;
                    line-height: 24px;
                    font-weight: bold;
                    color: #050f0f;
                  }
                }

                .right-container {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  user-select: none;
                  cursor: pointer;

                  span {
                    font-size: 14px;
                    line-height: 18px;
                    color: #829191;
                    margin-right: 10px;
                    user-select: none;
                    cursor: pointer;
                  }

                  img {
                    user-select: none;
                    cursor: pointer;

                    &.on {
                      transform: rotate(180deg);
                    }
                  }
                }
              }

              .isSensitive-container {
                width: 280px;
              }

              .isSensitive {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 62px;
                height: 18px;
                line-height: 18px;
                text-align: center;
                background: rgba(255, 85, 90, 0.1);
                border-radius: 2px;
                border: 1px solid #ff555a;
                font-size: 12px;
                color: #ff555a;
                // margin-top: 9px;
              }

              .description {
                width: 280px;
                font-size: 14px;
                line-height: 21px;
                color: #050f0f;
                padding: 9px 0 12px;
                border-top: 1px solid #dcdcdc;
                box-sizing: border-box;
              }

              .face-container {
                display: flex;
                flex-direction: column;
                background: rgba(185, 195, 195, 0.2);
                width: 100%;

                .btn {
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  height: 40px;
                  font-size: 14px;
                  color: #829191;
                  user-select: none;
                  cursor: pointer;

                  img {
                    margin-left: 8px;

                    &.on {
                      transform: rotate(180deg);
                    }
                  }
                }

                div.list {
                  position: relative;
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  flex-wrap: wrap;
                  padding: 0 20px;
                  box-sizing: border-box;

                  div {
                    position: relative;
                    width: 132px;
                    height: 74px;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                    margin-bottom: 16px;

                    p {
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      width: 100%;
                      height: 20px;
                      line-height: 20px;
                      text-align: center;
                      background: rgba(0, 0, 0, 0.7);
                      font-size: 13px;
                      color: #fff;
                    }

                    .border {
                      position: absolute;
                      top: 0;
                      left: 0;
                      border: 2px solid #ff555a;
                      border-radius: 6px;
                      box-sizing: border-box;
                    }
                  }
                }
              }
            }
          }
        }
        .videoRec-container {
          .ml {
            margin-left: 57px;
          }
          .btn {
            justify-content: flex-start;
            .logo {
              width: 16px;
              height: 16px;
              margin-right: 8px;
              margin-left: 18px;
            }
            .result {
              font-size: 14px;
              font-family: PingFang-SC-Medium, PingFang-SC;
              font-weight: 500;
              color: #829191;
              line-height: 20px;
            }
          }
          .empty {
            margin-top: 60px;
          }
          .result-success {
            width: 100px;
            height: 100px;
            background: rgba(#b9c3c3, 0.15);
            // opacity: 0.15;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              margin: 0;
            }
            & + span {
              margin-top: 10px;
            }
          }
          .full {
            width: 280px !important;
          }
          .js-title {
            line-height: 28px;
            background: #f9f9f9;
            box-shadow: 0 0 10px rgba(6, 21, 50, 0.05);
            font-size: 13px;
            font-family: PingFang-SC-Bold, PingFang-SC;
            font-weight: bold;
            color: #829191;
            padding-left: 17px;
            .time {
              width: 76px;
              display: inline-block;
            }
          }
          ul {
            box-shadow: 0 0 10px rgba(6, 21, 50, 0.05);
            li {
              display: flex;
              align-items: center;
              background: none;
              border-bottom: 1px solid #dcdcdc;
              &:last-child {
                border-bottom: 0;
              }
              &:hover {
                background: rgba(185, 195, 195, 0.15);
              }
              .js-time {
                font-size: 14px;
                font-family: Arial-BoldMT, Arial;
                font-weight: normal;
                color: #b9c3c3;
                line-height: 16px;
                display: flex;
                flex-direction: column;
                span {
                  width: 76px;
                }
              }
              .js-result {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #050f0f;
                line-height: 21px;
              }
            }
          }
        }
      }

      .bottom-container {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 80px;
        background: #f9f9f9;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 0 30px;
        box-sizing: border-box;

        .left-container {
          & > div {
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-radius: 40px;
            background: @green;
            font-size: 14px;
            color: #fff;
            user-select: none;
            cursor: pointer;

            &:hover {
              // .createList {
              //   display: flex;
              // }
              .btnHover;
            }
            &:active {
              .btnActive;
            }

            img {
              margin-right: 7.5px;
              
              // &.create {
              //   width: 22px;
              //   height: 18px;
              // }
            }

            .createList {
              position: absolute;
              top: 40px;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              width: 128px;
              // height: 130px;
              background: transparent;

              .h10 {
                height: 10px;
              }

              ul {
                width: 128px;
                // height: 120px;
                border-radius: 4px;
                background: rgba(5, 15, 15, 1);
                overflow: hidden;

                li {
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  height: 40px;

                  &:hover {
                    background: rgba(255, 255, 255, 0.1);

                    i.uploadIcon {
                      display: block;
                      width: 17px;
                      height: 22px;
                      background: url("../../assets/img/material/littleUploadIconOn.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                      margin-right: 10px;
                    }

                    i.reportIcon {
                      display: block;
                      width: 16px;
                      height: 16px;
                      background: url("../../assets/img/material/littleReportIconOn.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                      margin-right: 10px;
                    }

                    i.publicIcon {
                      display: block;
                      width: 18px;
                      height: 18px;
                      background: url("../../assets/img/material/littlePublicIconOn.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                      margin-right: 10px;
                    }

                    span {
                      font-size: 13px;
                      color: #fff;
                    }
                  }

                  img {
                    margin-right: 10px;
                  }

                  i.uploadIcon {
                    display: block;
                    width: 17px;
                    height: 22px;
                    background: url("../../assets/img/material/littleUploadIcon.svg")
                      no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                  }

                  i.reportIcon {
                    display: block;
                    width: 16px;
                    height: 16px;
                    background: url("../../assets/img/material/littleReportIcon.svg")
                      no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                  }

                  i.publicIcon {
                    display: block;
                    width: 18px;
                    height: 18px;
                    background: url("../../assets/img/material/littlePublicIcon.svg")
                      no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                  }

                  span {
                    font-size: 13px;
                    color: #b9c3c3;
                  }
                }
              }
            }
          }
        }

        .right-container {
          display: flex;
          flex-direction: row;
          align-items: center;

          & > div {
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border-radius: 40px;
            background: #fff;
            border: 1px solid @green;
            color: @green;
            font-size: 14px;
            margin-left: 20px;
            box-sizing: border-box;
            user-select: none;
            cursor: pointer;

            &:hover {
              .btnHover;
            }
            &:active {
                .btnActive;
            }

            img {
              margin-right: 10px;
            }

            // &:hover {
            //   .createList {
            //     display: flex;
            //   }
            // }

            .createList {
              position: absolute;
              top: 40px;
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
              width: 128px;
              // height: 130px;
              background: transparent;

              .h10 {
                height: 10px;
              }

              ul {
                width: 128px;
                // height: 120px;
                border-radius: 4px;
                background: rgba(5, 15, 15, 1);
                overflow: hidden;

                li {
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-items: center;
                  width: 100%;
                  height: 40px;

                  &:hover {
                    background: rgba(255, 255, 255, 0.1);

                    i.uploadIcon {
                      display: block;
                      width: 17px;
                      height: 22px;
                      background: url("../../assets/img/material/littleUploadIconOn.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                      margin-right: 10px;
                    }

                    i.reportIcon {
                      display: block;
                      width: 16px;
                      height: 16px;
                      background: url("../../assets/img/material/littleReportIconOn.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                      margin-right: 10px;
                    }

                    i.publicIcon {
                      display: block;
                      width: 18px;
                      height: 18px;
                      background: url("../../assets/img/material/littlePublicIconOn.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                      margin-right: 10px;
                    }

                    i.eightIcon {
                      display: block;
                      width: 25px;
                      height: 20px;
                      background: url("../../assets/img/common/800k.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                      margin-right: 10px;
                    }

                    i.originIcon {
                      display: block;
                      width: 26px;
                      height: 19px;
                      background: url("../../assets/img/common/HD.svg")
                        no-repeat;
                      background-position: center center;
                      background-size: 100% 100%;
                      margin-right: 10px;
                    }

                    span {
                      font-size: 13px;
                      color: #fff;
                    }
                  }

                  img {
                    margin-right: 10px;
                  }

                  i.uploadIcon {
                    display: block;
                    width: 17px;
                    height: 22px;
                    background: url("../../assets/img/material/littleUploadIcon.svg")
                      no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                  }

                  i.reportIcon {
                    display: block;
                    width: 16px;
                    height: 16px;
                    background: url("../../assets/img/material/littleReportIcon.svg")
                      no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                  }

                  i.publicIcon {
                    display: block;
                    width: 18px;
                    height: 18px;
                    background: url("../../assets/img/material/littlePublicIcon.svg")
                      no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                  }

                  i.eightIcon {
                    display: block;
                    width: 25px;
                    height: 20px;
                    background: url("../../assets/img/common/800k.svg")
                      no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                  }

                  i.originIcon {
                    display: block;
                    width: 26px;
                    height: 19px;
                    background: url("../../assets/img/common/HD.svg") no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 10px;
                  }

                  span {
                    font-size: 13px;
                    color: #b9c3c3;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
